import { UrlParam } from '@/lib/url/url-param.hook'

import { toast } from '@/components/lemmala-design-system/toast/use-toast'

import { COMMENT_LABELS } from './labels'

export const copyCommentLink = async (commentId: string) => {
  const url = new URL(window.location.href)
  url.searchParams.set(UrlParam.COMMENT_ID, commentId)
  await navigator.clipboard.writeText(url.href)
  toast({ title: COMMENT_LABELS.linkCopied, variant: 'success' })
}
